import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import type { ObjectDetailsHeaderAction } from 'framework/ViewTypes/contentLayout';
import type { PositionProfile } from '../../types';
import { POSITION_PROFILE_STATUSES } from '../../constants';

type PositionProfileHeaderActions = {
  onEdit: () => void;
  onDeprecate: () => void;
  onReactivate: () => void;
  onRetire: () => void;
};

type PositionProfileHeaderPermissions = {
  canUpdate: boolean;
  canDeprecate: boolean;
  canReactivate: boolean;
  canRetire: boolean;
};

export const getPositionProfileHeaderActions = (
  profile: PositionProfile,
  { onEdit, onDeprecate, onReactivate, onRetire }: PositionProfileHeaderActions,
  { canUpdate, canDeprecate, canReactivate, canRetire }: PositionProfileHeaderPermissions,
): ObjectDetailsHeaderAction[] => {
  const actions: ObjectDetailsHeaderAction[] = [];

  if (profile.status === POSITION_PROFILE_STATUSES.ACTIVE) {
    if (canUpdate) {
      actions.push({
        id: 'edit-profile',
        label: 'Edit position profile',
        icon: <EditOutlinedIcon />,
        variant: 'outlined',
        tooltip: 'Edit position profile',
        onClick: onEdit,
      });
    }
    if (canDeprecate) {
      actions.push({
        id: 'deprecate-profile',
        label: 'Deprecate position profile',
        icon: <PauseOutlinedIcon />,
        variant: 'outlined',
        tooltip: 'Deprecate position profile',
        onClick: onDeprecate,
      });
    }
  } else if (profile.status === POSITION_PROFILE_STATUSES.DEPRECATED) {
    if (canReactivate) {
      actions.push({
        id: 'reactivate-profile',
        label: 'Reactivate position profile',
        icon: <PlayArrowOutlinedIcon />,
        variant: 'outlined',
        tooltip: 'Reactivate position profile',
        onClick: onReactivate,
      });
    }
    if (canRetire && !profile.nonRetiredLinkedPositionsCount) {
      actions.push({
        id: 'retire-profile',
        label: 'Retire position profile',
        icon: <DoDisturbIcon />,
        color: 'error',
        variant: 'outlined',
        tooltip: 'Retire position profile',
        onClick: onRetire,
      });
    }
  }

  return actions;
};
